import * as React from "react";
import Loading, { FontSize } from "../../misc/components/loading";
import { TestQualityGrade } from "./TestQualityGrading";

interface TestQualityGradeIndicatorProps {
    title: string;
    loading: boolean;
    grade: TestQualityGrade;
}

export const TestQualityGradeIndicator = ({ title, loading, grade }: TestQualityGradeIndicatorProps) => {
    let qualityColour = "badge-info";

    switch (grade) {
        case TestQualityGrade.A:
            qualityColour = "badge-success";
            break;
        case TestQualityGrade.B:
            qualityColour = "badge-success";
            break;
        case TestQualityGrade.C:
            qualityColour = "badge-warning";
            break;
        case TestQualityGrade.D:
            qualityColour = "badge-warning";
            break;
        case TestQualityGrade.E:
            qualityColour = "badge-danger";
            break;
        case TestQualityGrade.U:
            qualityColour = "badge-danger";
            break;
        case TestQualityGrade.F:
            qualityColour = "badge-danger";
            break;
    }

    return (
        <div className="row">
            <div className="col-md-6">
                {title}:
            </div>
            <div className="col-md-6">
                {loading
                    ? <Loading style={{ display: "inline-block" }} className={"text-left text-info"} size={FontSize.OneX} />
                    : <span className={`badge ${qualityColour}`}>{grade}</span>
                    }
            </div>
        </div>
    );
}
